export default {
  namespaced: true,
  state: {
    alertKegList: [],
  },
  getters: {
    
  },
  mutations: {
    setAlertKegListData(state, data) {
      state.alertKegList.splice(0);
      for (const d of data) {
        state.alertKegList.push(d);
      }
    },
    updateAlertKeg(state, data) {
      for (let i=0;i<state.alertKegList.length;i++) {
        if (state.alertKegList[i].serial === data.serial) {
          state.alertKegList.splice(i, 1, data);
          return;
        }
      }
      state.alertKegList.push(data);
    },
    removeAlertKeg(state, serial) {
      for (let i=0;i<state.alertKegList.length;i++) {
        if (state.alertKegList[i].serial === serial) {
          state.alertKegList.splice(i, 1);
          return;
        }
      }
    },
  },
  actions: {
    async refreshAlertKegList({ commit, dispatch }) {
      const res = await dispatch('api/getAlertKegListPromise', null, { root: true });
      commit('setAlertKegListData', res);
    },
    async createAlertKegs({ commit, dispatch }, kid) {
      const res = await dispatch('api/postCreateAlertKegPromise', kid, { root: true });
      commit('updateAlertKeg', res);
    },
    async deleteKeg({ commit, dispatch }, serial) {
      await dispatch('api/postDeleteAlertKegPromise', serial, { root: true });
      commit('removeAlertKeg', serial);
    },
    checkKidNeedAlert({state}, kid) {
      for (const ak of state.alertKegList) {
        if (ak.kid === kid) {
          return true;
        }
      }
      return false;
    }
  }

}
